import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/whmcs': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 161l-29.1 7-2.2 12.1 20.9 18.8-10.3 20.1-28.8-8.8-7.8 8.1 8.8 28-20.4 12.1-20.7-21.6-11.6 3.5-6.7 28.8-22.6-0.3-6.7-28.5-11.6-2.9-19.4 20.4-19.9-11.6 8.1-26.9-7.2-8.6-29.6 7.5-10.4-18.5 20.1-19.9-2.4-12.1-28.8-7.5 0.3-21.7 28.5-7.8 2.9-10.4-20.7-21 11-19.1 28.5 7.5 8.1-8.4-8.1-27.7 19.4-11 19.7 21 12.1-3.2 6.2-26.4h22.6l7 26.4 10.7 3.2 21.3-21 19.1 11.6-7.5 28.2 7.2 7.5 29-7.5 10.4 19.4-20.1 20.7 2.2 10.4 28.5 8.8v21.3zM328.8 206.2c31.4 0 56.8-25.3 56.8-56.8 0-31.4-25.4-56.8-56.8-56.8-31.4 0-56.8 25.4-56.8 56.8 0 31.4 25.5 56.8 56.8 56.8zM401.1 222.6l46.9 14.5v39.9l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-0.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1 0.5-40.9 53.5-14.7 5.7-19.7-38.9-39.4 20.7-35.8 53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4 22.7-6.1 11.6-52h42.4l11.6 45.9-22.6-5.9-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-0.3 1-23.8 6.5-6.2 1.7-0.1 6.4-0.2 12.9c-47.5 10.4-83.3 52.8-83.3 103.5 0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2 0.2 6.9 0.1 1.6-6.7 5.6-24 1.9-0.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/whmcs.js
// module id = 1090
// module chunks = 0